<header app-account-header></header>

<router-outlet></router-outlet>

<footer app-account-footer></footer>
